module.exports = __webpack_public_path__ + "static/media/onboarding-step-01.0cf863e6.png";